import CRUDService from '@/services/hrsg/CRUDService';

export class NotificationRecipientService extends CRUDService {
  constructor () {
    super('reviews.notification-recipients');
  }
}

export default new NotificationRecipientService();
